import React from 'react'
import { VitalityExerciseProvider } from './VitalityExerciseProvider'
import VitalityExercisePageOne from './VitalityExercisePageOne'
import VitalityExercisePageTwo from './VitalityExercisePageTwo'

const VitalityExercise = ({ section, ...props }) => {
  return (
    <VitalityExerciseProvider {...props}>
      <div>
        {section === 0 && <VitalityExercisePageOne />}
        {section === 1 && <VitalityExercisePageTwo />}
      </div>
    </VitalityExerciseProvider>
  )
}

export default VitalityExercise
